import React, { Component } from 'react';
import Header from '../../component/header';
import sHelpers from '../../modules/helpers/statichelpers';
export default class Logout extends Component {

    componentWillMount() {
        sHelpers.removeStoredData();
    }

    render() {
        return (
            <>
                <Header></Header>

                <div class="container">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div class="wrapper-content bg-white pinside60">
                                <div class="row">
                                    <div class="offset-xl-3 col-xl-6 offset-lg-3 col-lg-6 col-md-12 col-sm-12 col-12">
                                        <div class="error-ctn text-center">
                                            <h1 class="error-title mb40">You have been logged out.</h1>
                                            <a href="/home" class="btn btn-secondary text-center btn-bg">Go To Homepage</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

}